/**
 * Rich Text Editor default sample
 */
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { HtmlEditor, Image, Inject, Link, QuickToolbar, RichTextEditorComponent, Toolbar, Table, Video, Audio, PasteCleanup } from '@syncfusion/ej2-react-richtexteditor';
import './index.css';
import { useFileUpload } from "hooks/useFileUpload";
import { API_ENDPOINTS } from "constants";
import { NEW_ITEM_ID } from "constants";
import { useAuth0 } from "@auth0/auth0-react";
import { SERVER } from "constants";
import { useLoadImageWithAuth } from "hooks/apiHooks";
import { refreshBlobUrlsEditor } from "hooks/apiHooks";
function TextEditor({initialContent, onChange, id}) {
    const [content, setContent] = useState(initialContent);
    const fileUpload = useFileUpload(API_ENDPOINTS.UPLOADS.FILE_UPLOAD(NEW_ITEM_ID), false)
    const { getAccessTokenSilently, isAuthenticated:isAuth0Authenticated, isLoading:isAuth0Loading } = useAuth0();
    const rteObj = useRef(null);
    const [token, setToken] = useState(null);
    const loadImageWithAuth = useLoadImageWithAuth();

    const [isPreviewMode, setIsPreviewMode] = useState(true);

    useEffect(() => {
        const fetchToken = async () => {
            const accessToken = await getAccessTokenSilently();
            setToken(accessToken);
        };
        fetchToken();
    }, []);

    useEffect(() => {
        refreshBlobUrlsEditor(initialContent, loadImageWithAuth).then(refreshedContent => setContent(refreshedContent))
    }, [initialContent]);

    function onEditorChange(e) {
        setContent(e.value);
        onChange(e.value);
    }

    const handleSave = () => {
        const editorInstance = rteObj.current;
        if (editorInstance) {
            const content = editorInstance.getHtml();
            onChange(content)
        }
    };

    const toolbarClick = (args) => {
        if (args?.item?.id === "save-button") {
            handleSave();
        }
    };

    const items = [
        {
            tooltipText: "Save",
            prefixIcon: "e-icons e-save",
            id: "save-button",
            visible: isPreviewMode
        }, '|',
        'Bold', 'Italic', 'Underline', 'StrikeThrough', '|', 'FontColor', 'BackgroundColor', '|',
        'FontName', 'FontSize', 'Formats', '|',
        'NumberFormatList', 'BulletFormatList', 'Alignments', 'Blockquote', '|', 
        'Outdent', 'Indent', '|', 'CreateLink', 'CreateTable', '|', 'ClearFormat', 'SourceCode', 'Image'
    ];

    const toolbarSettings = {
        items: items
    };
    /*const slashMenuSettings = {
        enable: true,
        items: ['Paragraph', 'Heading 1', 'Heading 2', 'Heading 3', 'Heading 4', 'OrderedList', 'UnorderedList', 'Blockquote', 'Link', 'Table' ]
    };*/
    
    const insertImageSettings = {
        saveFormat: 'Blob', 
        allowedTypes: ['.jpg', '.jpeg', '.png', '.gif'],
        saveUrl: `${SERVER}${API_ENDPOINTS.UPLOADS.FILE_UPLOAD(NEW_ITEM_ID)}`,
    };

    const handleBeforeUpload = async (args) => {
        args.cancel = true;
        const file = args.fileData.rawFile

        const formData = new FormData();
        formData.append('files', args.fileData.rawFile);

        fileUpload.sendFile(formData).then(async response => {
            let response_1 = response[0]
            response_1['name'] = response_1.filename
            response_1['url'] = `/${response_1.unique_filename}`
            const url = await loadImageWithAuth(API_ENDPOINTS.UPLOADS.DOWNLOAD(response_1.id)); 
            console.log(url)
            args.fileData.url = url;
            args.fileData.backendId = response_1.id;
            if (rteObj.current) {
                const newImageHtml = `<img src="${url}" alt="${file.name}" filename="${file.name}" data-backend-id="${response_1.id}" class="e-rte-image" style="width: auto; height: auto;">`;
                rteObj.current.executeCommand('insertHTML', newImageHtml);
            }
        })
    };
                      
    return (<div className='control-pane'>
            <div className='control-section' id="rte">
                <div className='rte-control-section'>
                    <RichTextEditorComponent 
                        value={content} 
                        id={id || "defaultRTE"}
                        ref={rteObj} 
                        change={onEditorChange}
                        toolbarSettings={toolbarSettings}
                        insertImageSettings={insertImageSettings}
                        imageUploading={handleBeforeUpload} 
                        toolbarClick={toolbarClick}
                        saveInterval={10}
                    >
                        <Inject services={[HtmlEditor, Toolbar, Image, Link, QuickToolbar, Table, Video, Audio, PasteCleanup]}/>
                    </RichTextEditorComponent>
                </div>
            </div>
        </div>);
}
export default TextEditor;




/*
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { HtmlEditor, Image, Inject, Link, QuickToolbar, RichTextEditorComponent, Toolbar, Table, Video, Audio, PasteCleanup } from '@syncfusion/ej2-react-richtexteditor';
import './index.css';
function TextEditor({initialContent, onChange, id}) {
    const [content, setContent] = React.useState(initialContent);
    let rteObj;

    useEffect(() => {
        setContent(initialContent);
    }, [initialContent]);

    function onEditorChange(e) {
        setContent(e.value);
        onChange(e.value);
    }

    const items = [
        'Bold', 'Italic', 'Underline', 'StrikeThrough', '|', 'FontColor', 'BackgroundColor', '|',
        'FontName', 'FontSize', 'Formats', '|',
        'NumberFormatList', 'BulletFormatList', 'Alignments', 'Blockquote', '|', 
        'Outdent', 'Indent', '|', 'CreateLink', 'CreateTable', '|', 'ClearFormat', 'SourceCode'
    ];

    //Rich Text Editor ToolbarSettings
    const toolbarSettings = {
        items: items
    };
    const slashMenuSettings = {
        enable: true,
        items: ['Paragraph', 'Heading 1', 'Heading 2', 'Heading 3', 'Heading 4', 'OrderedList', 'UnorderedList', 'Blockquote', 'Link', 'Table' ]
    };
                      
    return (<div className='control-pane'>
            <div className='control-section' id="rte">
                <div className='rte-control-section'>
                    <RichTextEditorComponent 
                        value={content} 
                        id={id || "defaultRTE"}
                        ref={(richtexteditor) => { rteObj = richtexteditor; }} 
                        change={onEditorChange}
                        toolbarSettings={toolbarSettings}
                        slashMenuSettings={slashMenuSettings}
                    >
                        <Inject services={[HtmlEditor, Toolbar, Image, Link, QuickToolbar, Table, Video, Audio, PasteCleanup]}/>
                    </RichTextEditorComponent>
                </div>
            </div>
        </div>);
}
export default TextEditor;
*/



/*import { createRoot } from 'react-dom/client';
import './index.css';
import React, { useRef, useState } from 'react';
import { addClass, removeClass, Browser } from '@syncfusion/ej2-base';
import { RichTextEditorComponent, Toolbar, Inject, Image, Link, HtmlEditor, Count, QuickToolbar, Table, EmojiPicker, Video, Audio, FormatPainter, PasteCleanup, ImportExport, SlashMenu } from '@syncfusion/ej2-react-richtexteditor';
import { FileManager } from '@syncfusion/ej2-react-richtexteditor';
import { createElement } from '@syncfusion/ej2-base';

import * as CodeMirror from 'codemirror';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/css/css.js';
import 'codemirror/mode/htmlmixed/htmlmixed.js';
const TextEditor = ({initialContent, onChange}) => {
    const editor = useRef(null);
    const [content, setContent] = useState(initialContent);

    let mention;
    let codeMirror;
    const hostUrl = 'https://services.syncfusion.com/react/production/';
    // Rich Text Editor items list
    const items = [
        'Bold', 'Italic', 'Underline', 'StrikeThrough', 'SubScript', '|',
        'FontName', 'FontSize', 'FontColor', 'BackgroundColor', '|',
        'LowerCase', 'UpperCase', '|',
        'Formats', 'Alignments', 'Blockquote', '|', 'NumberFormatList', 'BulletFormatList', '|',
        'Outdent', 'Indent', '|', 'CreateLink', 'Image', 'FileManager', 'Video', 'Audio', 'CreateTable', '|', 'FormatPainter', 'ClearFormat',
        '|', 'EmojiPicker', 'Print', '|',
        'SourceCode'
    ];

    const fileManagerSettings = {
        enable: true,
        path: '/Pictures/Food',
        ajaxSettings: {
            url: 'https://ej2-aspcore-service.azurewebsites.net/api/FileManager/FileOperations',
            getImageUrl: 'https://ej2-aspcore-service.azurewebsites.net/api/FileManager/GetImage',
            uploadUrl: 'https://ej2-aspcore-service.azurewebsites.net/api/FileManager/Uplo ad',
            downloadUrl: 'https://ej2-aspcore-service.azurewebsites.net/api/FileManager/Download'
        }
    };
    const quickToolbarSettings = {
        table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles'],
        showOnRightClick: true,
    };
    const insertImageSettings = {
        saveUrl: hostUrl + 'api/RichTextEditor/SaveFile',
        removeUrl: hostUrl + 'api/RichTextEditor/DeleteFile',
        path: hostUrl + 'RichTextEditor/'
    };


    function mirrorConversion(e) {
        console.log('mirror', e, CodeMirror, codeMirror)
        const id = editor.current.getID() + 'mirror-view';
    
        const rteContainer = editor.current.element.querySelector('.e-rte-container');
        let mirrorView = editor.current.element.querySelector('#' + id);
        console.log(id, rteContainer, mirrorView);
    
        if (e.targetItem === 'Preview') {
            // Update the editor content from CodeMirror value
            editor.current.value = codeMirror.getValue();
            editor.current.dataBind();
            rteContainer.classList.remove('e-rte-code-mirror-enabled');
            editor.current.focusIn();
            
            // Update state to reflect the current content
            setContent(editor.current.value);
        } else {
            rteContainer.classList.add('e-rte-code-mirror-enabled');
            rteContainer.classList.remove('e-source-code-enabled');
    
            if (!mirrorView) {
                mirrorView = createElement('div', { className: 'rte-code-mirror', id: id, styles: 'display: none;' });
                rteContainer.appendChild(mirrorView);
                renderCodeMirror(mirrorView, editor.current.value === null ? '' : editor.current.value);
            } else {
                codeMirror.setValue(editor.current.value);
            }
    
            codeMirror.focus();
        }
    }
    

    function renderCodeMirror(mirrorView, content) {
        codeMirror = CodeMirror(mirrorView, {
            value: content,
            lineNumbers: true,
            mode: 'text/html',
            lineWrapping: true,
        });
    }
    function actionCompleteHandler(e) {
        if (e.targetItem && (e.targetItem === 'SourceCode' || e.targetItem === 'Preview')) {
            mirrorConversion(e);
        }
    }
    function actionBeginHandler(e) {
        if (e.requestType === 'EnterAction' && mention && mention.element.classList.contains('e-popup-open')) {
            e.cancel = true;
        }
    }

    function onEditorChange(e) {
        console.log(e)
        setContent(e.value);
        onChange(e.value);
    }

    return (<div className='control-pane'>
            <div className='control-section' id="rteTools">
                <div className='rte-control-section'>
                    <RichTextEditorComponent 
                        id="toolsRTE" 
                        ref={editor} 
                        value={content} 
                        showCharCount={false} 
                        actionBegin={actionBeginHandler} 
                        actionComplete={(e) => {
                            actionCompleteHandler(e);
                        }}
                        change={onEditorChange}
                        toolbarSettings={toolbarSettings} fileManagerSettings={fileManagerSettings} 
                        quickToolbarSettings={quickToolbarSettings} enableTabKey={true} 
                        insertImageSettings={insertImageSettings} enableXhtml={true} 
                        placeholder='Type something or use @ to tag a user...' 
                        slashMenuSettings={slashMenuSettings}>
                        <Inject services={[Toolbar, Image, Link, HtmlEditor, Count, QuickToolbar, Table, FileManager, EmojiPicker, Video, Audio, FormatPainter, PasteCleanup, SlashMenu, ImportExport]}/>
                    </RichTextEditorComponent>
                </div>
            </div>

        </div>);
}
export default TextEditor;
*/